import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReplaySubject } from 'rxjs';
import { NewVulnerabilityService } from 'src/app/Data Service/new-vulnerability.service';
import { AppComponent } from 'src/app/app.component';
import { SourceTitle, TargetTitle } from './IDropdown';
import { Target } from '@angular/compiler';

@Component({
  selector: 'app-admin-view',
  templateUrl: './admin-view.component.html',
  styleUrls: ['./admin-view.component.css']
})
export class AdminViewComponent implements OnInit{

  productForm: UntypedFormGroup;
  Eid : string = "";
  DDdataEVCVE:any;
  DDdataEVContrName:any;
  DDdataEVContrNum:any;
  DDdata:any;
  DDdataEVClient:any;
  // public RiskTitleServerSideCtrl: FormControl<string> = new FormControl<string>(null);
  // public  filteredServerSideBanks: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  // public  filteredRiskTitle: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  // public bankServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');
  // public bankServerSideCtrl: FormControl<string> = new FormControl<string>(null);
  // public  filteredContName: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  // public ContNameServerSideCtrl: FormControl<string> = new FormControl<string>(null);
  // public ContNameServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');
  
  
  public SourceVulServerSideCtrl: FormControl<SourceTitle> = new FormControl<SourceTitle>(null);
  public SourceVulServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');
  public  filteredSource: ReplaySubject<SourceTitle[]> = new ReplaySubject<SourceTitle[]>(1);

  public TargetVulServerSideCtrl: FormControl<TargetTitle> = new FormControl<TargetTitle>(null);
  public TargetVulServerSideFilteringCtrl: FormControl<string> = new FormControl<string>('');
  public  filteredTargetVul: ReplaySubject<TargetTitle[]> = new ReplaySubject<TargetTitle[]>(1);
  
  sourceTitleOptions : SourceTitle[] = [];
  targetTitleOptions : TargetTitle[] = [];
  public errormessage: string = '';
  SrcTitleData : string = '';
  TargetTitleData : string = '';
  isButtonDisabled: boolean = true;

  constructor(private spinner: NgxSpinnerService,private service : NewVulnerabilityService,private router: Router,private fb:UntypedFormBuilder,private appComponent :AppComponent) {
    this.productForm = this.fb.group({
      ClientDD:"",
      ContractDD:"",
      ContNameDD:"",      
      CVEDD :"",
      // bankServerSideCtrl : "",
      SourceVulServerSideCtrl : "",
      sourceContNum : "",
      targetContNum : ""
      // quantities: this.fb.array([]),
      // contracts_arrayEV:this.fb.array([])
    });

     this.Eid = localStorage.getItem('UserID').substring(0,localStorage.getItem('UserID').lastIndexOf("@"));
    //  this.Eid = "ujjwal.singh.kumar";     
     
   }

  ngOnInit(): void {
    console.log("ng init");
    this.getSourceTitleDD();
    this.getTargetTitleDD();
    this.checkValue();
  }

  getSourceTitleDD(){
    this.service.getSourceTitleDropDownData().subscribe((data : any)=>{      
      // this.DDdataEVCVE = data;  
      // this.filteredOptions = data;
      // this.filteredTitle = data;
      // this.options = data;
      let resultData = [];
      console.log("source tile");
      console.log(data);
      for (let index = 0; index < data.length; index++) {
        this.sourceTitleOptions[index] = data[index].SourceVulnerabilityTitle;
      }
      console.log("Source title options ")
      console.log(this.sourceTitleOptions);
      this.filteredSource.next(this.sourceTitleOptions.slice());
    }, (error:any) => {
        this.errormessage = error;
    })

  }

  getTargetTitleDD(){
    this.service.getTargetTitleDropDownData().subscribe((data : any)=>{      
      // this.DDdataEVCVE = data;  
      // this.filteredOptions = data;
      // this.filteredTitle = data;
      // this.options = data;
      let resultData = [];
      for (let index = 0; index < data.length; index++) {
        this.targetTitleOptions[index] = data[index].TargetVulnerabilityTitle;
      }
      console.log("Target title options ")
      console.log(this.targetTitleOptions);
      this.filteredTargetVul.next(this.targetTitleOptions.slice());
    }, (error:any) => {
        this.errormessage = error;
    })

  }

  onSrcVulSelChange(event: any) {
    console.log('Selected value:', event.value);

    const varTitle = event.value;
    this.SrcTitleData = event.value;
    var SrcFilterData = {

      SrcTitle: varTitle == null ? null : varTitle.toString(),
    }
    if (SrcFilterData.SrcTitle == "" || SrcFilterData.SrcTitle == null) {
      alert("Please choose an option!")

    }
    else {
      this.getSourceTitleCount(SrcFilterData);

    }

  }

  getSourceTitleCount(FilterData: any) {
    this.spinner.show();
    this.service.GetSrcNACData(FilterData).subscribe(
      (data: any) => {
        // this.productForm.setControl("sourceContNum", data);
        this.productForm.get('sourceContNum')?.setValue(data[0].SrcTitle);
            this.spinner.hide();  
        
      }

    )
  }

  onTargetVulSelChange(event: any) {
    console.log('Target Selected value:', event.value);

    const varTitle = event.value;
    this.TargetTitleData = varTitle;
    if (this.SrcTitleData == "" || this.SrcTitleData == null) {
      alert("Please choose a Source Title option!")

    }

    var TargetFilterData = {

      TargetTitle: varTitle == null ? null : varTitle.toString(),
      SrcTitle : this.SrcTitleData == null ? null : this.SrcTitleData.toString()
    }
    if (TargetFilterData.TargetTitle == "" || TargetFilterData.TargetTitle == null) {
      alert("Please choose an option!")

    }
    else {
      this.getTargetTitleCount(TargetFilterData);
      this.productForm.get('targetContNum')?.valueChanges.subscribe(value => {
        this.checkValue();
      })
    }

  }

  getTargetTitleCount(FilterData: any) {
    this.spinner.show();
    this.service.GetTargetMatchData(FilterData).subscribe(
      (data: any) => {
        // this.productForm.setControl("sourceContNum", data);
        this.productForm.get('targetContNum')?.setValue(data[0].matchingContNum);
            this.spinner.hide();  
        
      }

    )
  }

  checkValue(): void {
    const value = this.productForm.get('targetContNum')?.value;
    console.log("check "+value);
    // this.isButtonDisabled = value <= 0;
    this.isButtonDisabled = !value || value <= 0;
    console.log("button dis : "+this.isButtonDisabled);
  }

  UpdateData() : void{
    console.log("update called")

    var val = {            
      srcTitle : this.SrcTitleData,
      targetTitle : this.TargetTitleData,
      UpdatedBy : this.Eid         
  }      
     this.service.UpdateTargetContracts(val).subscribe(res => {
       alert(res.toString());
  });


  }

}
